/* Batida B2B views - shared helpers (window.BKV). 25.09, Aleksandra's specs (category page, product page v2, panel).
   Products come in one JSON shape (snippets/batida-b2b-product-json.liquid); prices are in grosze, gross (VAT included),
   net = gross / (1 + vat). The company discount tier (0/5/7/10) comes from the B2B market (b2b-5/7/10); the real discount
   is Shopify's automatic discount in the cart, the pages only show it.
   Review mode (for the team before launch): only on an unpublished theme (preview link), ?podglad=firma shows the pages
   as a logged-in company with the review snapshot (assets/batida-b2b-review-data.json, the 35 draft products) and
   ?rabat=5|7|10 a tier. It never runs on the published theme. ?podglad=0 switches it off. */
(function () {
  if (window.BKV) return;
  var KEY_REVIEW = 'bk-podglad', KEY_TIER = 'bk-rabat', KEY_FAV = 'bk-fav', KEY_FAV_ACC = 'bk-fav-acc', KEY_COFFEE = 'bk-coffee';
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };
  var session = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }
  };
  var params = new URLSearchParams(location.search);
  var themeRole = (window.Shopify && Shopify.theme && Shopify.theme.role) || '';
  var previewable = themeRole !== 'main' || /shopifypreview\.com$/.test(location.hostname);
  if (previewable && params.has('podglad')) session.set(KEY_REVIEW, params.get('podglad') === 'firma' ? '1' : null);
  if (previewable && params.has('rabat')) session.set(KEY_TIER, String(parseInt(params.get('rabat'), 10) || 0));
  var review = previewable && session.get(KEY_REVIEW) === '1';

  /* 3.10 (Aleksandra: b2b.batida.pl in EN/DE/FR/UK): texts come from window.bkvT (snippets/batida-b2b-i18n-js.liquid, locale
     keys batida.b2b_js / b2b_cat / b2b_pdp); a missing text falls back to the Polish literal. [name] = a value filled in here.
     Review mode (?podglad=firma, team only) stays Polish. */
  function t(k, fb, vars) {
    var D = window.bkvT || {}, s = typeof D[k] === 'string' && D[k] ? D[k] : fb;
    if (vars) Object.keys(vars).forEach(function (v) { s = s.split('[' + v + ']').join(vars[v]); });
    return s;
  }
  /* coffee pairing text "Brazylia lub Honduras · palenie średnie/ciemne" in the page language (the value stays Polish: filters
     and the company coffee profile compare it); pair_map = "pl=xx|pl=xx", longest first */
  function pairText(s) {
    s = String(s == null ? '' : s);
    String(t('pair_map', '-')).split('|').forEach(function (kv) { var i = kv.indexOf('='); if (i > 0) s = s.split(kv.slice(0, i)).join(kv.slice(i + 1)); });
    return s;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function zlRound(grosze) { var n = Math.round(Number(grosze) || 0); return n % 100 ? zl(n) : (n / 100) + ' zł'; }   /* thresholds: 1050 zł, 49,20 zł */
  function fdRates() {
    var r = window.batidaFD && window.batidaFD.rates;
    /* no bar on the page = the company terms (3.10, Aleksandra: 40 zł netto, free from 1000 zł netto; was the consumer 500 zł) */
    return r && r.b2b ? r : { freeFrom: 50000, warsaw: 5000, okolice: 7500, b2b: { on: true, freeFrom: 100000, freeFromNet: 100000, price: 4920 } };
  }
  /* 29.09 (Aleksandra): every price with grosze and "zł", the same as batida.pl - window.batidaMoney is the site-wide
     helper (layout/theme.liquid, the shop's money format: "49,20 zł", "1.155,00 zł") */
  function zl(grosze) {
    if (window.batidaMoney) return window.batidaMoney(Number(grosze) || 0);
    var v = (Number(grosze) || 0) / 100; return v.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł';
  }
  function tier(root) {
    if (review) { var t = parseInt(session.get(KEY_TIER), 10); if (!isNaN(t)) return t; }
    var el = root && root.closest ? root.closest('[data-tier]') : document.querySelector('[data-tier]');
    return el ? (parseInt(el.getAttribute('data-tier'), 10) || 0) : 0;
  }
  function net(p) { return Math.round(p.price / (1 + (p.vat || 5) / 100)); }
  /* like Shopify and the invoice: the discount comes off the gross price, net is worked out from that */
  function netAfter(p, t) { return Math.round(p.price * (1 - (t || 0) / 100) / (1 + (p.vat || 5) / 100)); }
  function grossAfter(p, t) { return Math.round(p.price * (1 - (t || 0) / 100)); }
  /* net of a whole line, rounded once (like the invoice): qty × gross after discount ÷ (1 + VAT) */
  function lineNet(p, qty, t) { return Math.round(p.price * (1 - (t || 0) / 100) * qty / (1 + (p.vat || 5) / 100)); }

  /* "Brazylia lub Honduras · palenie średnie/ciemne" -> {origins:[Brazylia, Honduras], roasts:[średnie, ciemne]} */
  var ROASTS = ['jasne', 'średnie', 'ciemne'];
  function parsePair(s) {
    s = String(s || ''); var parts = s.split('·'); var head = (parts[0] || '').trim(); var roastPart = (parts[1] || '').toLowerCase();
    var origins = /palenie|uniwersal|do kaw/i.test(head) ? [] : head.split(/\s+lub\s+|,\s*/).map(function (x) { return x.trim(); }).filter(Boolean);
    var roasts = [];
    if (/jasn/.test(roastPart)) roasts.push('jasne');
    if (/średni/.test(roastPart)) roasts.push('średnie');
    if (/ciemn/.test(roastPart)) roasts.push('ciemne');
    return { origins: origins, roasts: roasts, head: parts.slice(0, 2).join(' · ').trim() };
  }
  /* Coffee profile (Aleksandra 26.09): a logged-in company keeps it on the company account (the whole team sees
     it, on every device) via the B2B service (/apps/b2b-signup, action "coffee"); the section root carries the
     saved value (data-bkv-company-coffee). Everyone else, and review mode, keep it in this browser. */
  var companyInfo;
  function company() {
    if (companyInfo === undefined) {
      var el = document.querySelector('[data-bkv-company]'), saved = null;
      if (el) { try { saved = JSON.parse(el.getAttribute('data-bkv-company-coffee') || 'null'); } catch (e) { saved = null; } }
      companyInfo = el && !review ? { id: el.getAttribute('data-bkv-company'), coffee: saved && saved.origin ? { origin: saved.origin, roast: saved.roast || '' } : null } : null;
    }
    return companyInfo;
  }
  function coffee() { var co = company(); return co ? co.coffee : store.get(KEY_COFFEE, null); }
  function setCoffee(c) {
    c = c && c.origin ? { origin: c.origin, roast: c.roast || '' } : null;
    store.set(KEY_COFFEE, c);
    var co = company();
    if (co) {
      co.coffee = c;
      fetch(root + 'apps/b2b-signup', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ action: 'coffee', origin: c ? c.origin : '', roast: c ? c.roast : '', company: co.id }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j.ok) throw j; }); })
        .then(function () { toast(c ? t('coffee_saved', 'Zapisaliśmy profil kawy na koncie firmy - widzi go cały zespół.') : t('coffee_removed', 'Usunęliśmy profil kawy z konta firmy.')); })
        .catch(function () { toast(t('coffee_error', 'Nie udało się zapisać profilu na koncie firmy. Spróbuj jeszcze raz.')); });
    } else if (review && c) {
      toast('Podgląd: w sklepie profil kawy zapisze się na koncie firmy.');
    }
    document.dispatchEvent(new CustomEvent('bkv:coffee', { detail: c }));
  }
  function fitsCoffee(p, c) {
    c = c || coffee(); if (!c || !c.origin) return false;
    var pp = parsePair(p.pair); if (pp.origins.indexOf(c.origin) === -1) return false;
    return !c.roast || pp.roasts.length === 0 || pp.roasts.indexOf(c.roast) !== -1;
  }
  /* allergen list "gluten (pszenica), orzechy (migdały, pistacje), soja" -> items, respecting brackets */
  function splitList(s) {
    var out = [], depth = 0, cur = ''; String(s || '').split('').forEach(function (ch) {
      if (ch === '(') depth++; if (ch === ')') depth--;
      if (ch === ',' && depth === 0) { if (cur.trim()) out.push(cur.trim()); cur = ''; } else cur += ch;
    }); if (cur.trim()) out.push(cur.trim()); return out;
  }
  function hasAllergen(p, word) { return new RegExp(word, 'i').test(p.alg || ''); }

  var toastTimer;
  function toast(msg) {
    var el = document.querySelector('.bv-toast');
    if (!el) { el = document.createElement('div'); el.className = 'bv-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = msg; el.hidden = false; clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.hidden = true; }, 3200);
  }

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function cartFetch() { return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  /* net value of the cart: syrups 23% VAT, everything else 5% (the B2B range); total_price already has the discount */
  function cartNet(cart) {
    return (cart.items || []).reduce(function (s, it) {
      var vat = /syrop/i.test(it.product_type || '') ? 23 : 5; return s + Math.round(it.final_line_price / (1 + vat / 100));
    }, 0);
  }
  /* add [{id, quantity}] the way the drawer does (add.js -> cart.js -> theme:cart:change) */
  function cartAdd(items, label) {
    items = (items || []).filter(function (i) { return i && i.id && i.quantity > 0; });
    if (!items.length) return Promise.resolve(null);
    /* 3.10 (Aleksandra): before the official opening nothing goes into the cart (snippets/batida-b2b-soon-bar.liquid) */
    if (document.documentElement.classList.contains('is-b2b-soon')) { toast((window.bkbSoon && window.bkbSoon.msg) || t('soon_fallback', 'Zamawianie rusza wkrótce.')); return Promise.resolve(null); }
    if (review && !document.documentElement.classList.contains('is-b2b-customer')) {
      toast('Podgląd: w sklepie ' + (label || 'produkty') + ' trafią teraz do koszyka.'); return Promise.resolve(null);
    }
    return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return cartFetch(); })
      .then(function (cart) {
        try { document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true })); } catch (e) {}
        document.dispatchEvent(new CustomEvent('bkv:cart', { detail: cart }));
        toast(t('added', 'Dodano do koszyka[label]. Ilości zmienisz w koszyku.', { label: label ? ': ' + label : '' }));
        return cart;
      })
      .catch(function (e) { toast((e && (e.description || e.message)) || t('add_error', 'Nie udało się dodać do koszyka. Spróbuj jeszcze raz.')); return null; });
  }

  var snapshotPromise;
  function snapshot() {
    if (!snapshotPromise) {
      var url = (document.querySelector('[data-bkv-snapshot]') || {}).getAttribute ? document.querySelector('[data-bkv-snapshot]').getAttribute('data-bkv-snapshot') : '';
      snapshotPromise = url ? fetch(url).then(function (r) { return r.json(); }).then(function (j) {
        /* draft products open through their preview key on this preview host */
        (j.products || []).forEach(function (p) { if (p.preview) { try { var u = new URL(p.preview); p.url = location.origin + u.pathname + u.search; } catch (e) {} } });
        return j.products || [];
      }).catch(function () { return []; }) : Promise.resolve([]);
    }
    return snapshotPromise;
  }
  function readJSON(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  /* Ulubione (28.09, Pat: "build the real functionality"). A logged-in customer's favourites live on the account in
     Batida Connect (/apps/connect/b2b/favs through the app proxy; a company contact shares ONE list with the whole
     company, any other customer has their own). favs() stays synchronous, newest first: the last list read from the
     account is kept per customer in localStorage ('bk-fav-acc'), so the page renders at once, and the fresh list from
     Batida Connect replaces it a moment later (event 'bkv:favs'). The old browser list ('bk-fav', oldest first) is
     merged into the account once (POST {merge}) and then removed. Guests and review mode (?podglad=firma) keep the
     browser list. If Batida Connect doesn't answer (404 before its deploy, 5xx), the page quietly uses the browser list.
     The sections print data-bkv-customer (the logged-in customer's id) and data-bkv-company (current company).
     Hearts: any <button data-bkv-fav="<handle>"> is a toggle (aria-pressed; with data-bkv-fav-label the visible label
     changes instead: „Do ulubionych” / „W ulubionych”). Revert: git (the old favs()/toggleFav() were browser-only). */
  var FAV_URL = root + 'apps/connect/b2b/favs';
  var fav = { list: [], mode: 'local', acct: null, scope: '', ready: null, inflight: 0, rev: 0 };
  function account() {
    if (review) return null;
    var el = document.querySelector('[data-bkv-customer]'), id = el && el.getAttribute('data-bkv-customer');
    if (!id || !/^\d+$/.test(id)) return null;
    var co = document.querySelector('[data-bkv-company]');
    return { id: id, company: co ? String(co.getAttribute('data-bkv-company') || '').replace(/\D/g, '') : '' };
  }
  function cleanFavs(a) { var out = []; (Array.isArray(a) ? a : []).forEach(function (h) { if (typeof h === 'string' && h && out.indexOf(h) === -1) out.push(h); }); return out; }
  function localFavs() { return cleanFavs(store.get(KEY_FAV, [])).reverse(); }            /* 'bk-fav' is oldest first */
  function saveLocalFavs() { store.set(KEY_FAV, fav.list.slice().reverse()); }
  function accKey(a) { return a.id + ':' + (a.company || ''); }
  function saveAccFavs() { if (fav.acct) store.set(KEY_FAV_ACC, { key: accKey(fav.acct), favs: fav.list, scope: fav.scope, at: Date.now() }); }
  function favApi(method, body) {
    var q = fav.acct && fav.acct.company ? '?company=' + encodeURIComponent(fav.acct.company) : '';
    var h = { 'Accept': 'application/json' }; if (body) h['Content-Type'] = 'application/json';
    return fetch(FAV_URL + q, { method: method, credentials: 'same-origin', headers: h, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().catch(function () { return null; }).then(function (j) {
        if (!r.ok || !j || j.ok === false) { var e = new Error((j && j.error) || 'http ' + r.status); e.status = r.status; e.code = j && j.error; throw e; }
        return j;
      }); });
  }
  function takeServer(j) { fav.list = cleanFavs(j.favs); fav.scope = j.scope || fav.scope; fav.mode = 'account'; saveAccFavs(); }
  function listSet(h, on, at) {
    var i = fav.list.indexOf(h);
    if (on && i === -1) { if (at == null || at < 0) fav.list.unshift(h); else fav.list.splice(Math.min(at, fav.list.length), 0, h); }
    if (!on && i !== -1) fav.list.splice(i, 1);
  }
  /* 29.09: Batida's 'ulubione' icon (snippets/batida-icons-js.liquid); the old heart stays as the fallback */
  var FAV_ICON = (window.batidaIcon && window.batidaIcon('ulubione', 18).replace('class="bi bi--ulubione"', 'class="bi bi--ulubione bv-heart"')) || '<svg class="bv-heart" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  function isFav(h) { return fav.list.indexOf(h) !== -1; }
  function favButton(h, title, cls) {
    var on = isFav(h);
    return '<button type="button" class="bv-fav' + (cls ? ' ' + cls : '') + '" data-bkv-fav="' + esc(h) + '" aria-pressed="' + on + '" aria-label="' + esc(t('fav_aria', 'Ulubione: [title]', { title: title || h })) + '" title="' + esc(on ? t('fav_remove', 'Usuń z ulubionych') : t('fav_add', 'Dodaj do ulubionych')) + '">' + FAV_ICON + '</button>';
  }
  function syncFavButtons() {
    document.querySelectorAll('[data-bkv-fav]').forEach(function (b) {
      var on = isFav(b.getAttribute('data-bkv-fav'));
      if (b.hasAttribute('data-bkv-fav-label')) {
        b.classList.toggle('is-on', on);
        var tx = b.querySelector('[data-bkv-fav-text]'); if (tx) tx.textContent = on ? t('fav_on', 'W ulubionych') : t('fav_off', 'Do ulubionych');
      } else {
        b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.title = on ? t('fav_remove', 'Usuń z ulubionych') : t('fav_add', 'Dodaj do ulubionych');
      }
    });
  }
  function favEmit() {
    syncFavButtons();
    try { document.dispatchEvent(new CustomEvent('bkv:favs', { detail: { favs: fav.list.slice(), mode: fav.mode, scope: fav.scope } })); } catch (e) {}
  }
  function localAddMsg() {
    if (review) return 'Podgląd: zapisano w tej przeglądarce. W sklepie ulubione zapiszą się na koncie firmy.';
    if (fav.acct) return t('fav_saved_local', 'Zapisano w tej przeglądarce.');
    return t('fav_saved_local_guest', 'Zapisano w tej przeglądarce - zaloguj się, żeby ulubione były na koncie firmy.');
  }
  /* the change itself, once we know where the list lives (account or browser) */
  function commitFav(h, on, opts) {
    var at = fav.list.indexOf(h);
    listSet(h, on);
    if (fav.mode !== 'account') {
      saveLocalFavs(); favEmit();
      if (!opts.quiet) toast(on ? localAddMsg() : t('fav_removed', 'Usunięto z ulubionych.'));
      return Promise.resolve(true);
    }
    saveAccFavs(); favEmit(); fav.inflight++; fav.rev++;
    return favApi('POST', { handle: h, on: on }).then(function (j) {
      fav.inflight--; if (!fav.inflight) { takeServer(j); favEmit(); }       /* the account's list (colleagues' changes too) */
      if (!opts.quiet) toast(on ? t('fav_added', 'Dodano do ulubionych - znajdziesz je w panelu klienta.') : t('fav_removed', 'Usunięto z ulubionych.'));
      return true;
    }).catch(function (e) {
      fav.inflight--; listSet(h, !on, at); saveAccFavs(); favEmit();
      toast(e && e.code === 'limit' ? t('fav_full', 'Lista ulubionych jest pełna (200 produktów). Usuń coś, żeby dodać nowy.') : t('fav_error', 'Nie udało się zapisać ulubionych. Spróbuj jeszcze raz.'));
      return false;
    });
  }
  function setFav(h, on, opts) {
    opts = opts || {}; h = String(h || ''); if (!h) return Promise.resolve(false);
    if (fav.mode === 'pending') {                                              /* still asking the account: show it now, save after */
      listSet(h, on); favEmit();
      return fav.ready.then(function () { return commitFav(h, on, opts); });
    }
    return commitFav(h, on, opts);
  }
  function toggleFav(h, opts) { var on = !isFav(h); setFav(h, on, opts); return on; }
  function favs() { return fav.list.slice(); }
  function favInit() {
    var a = account();
    fav.acct = a;
    if (!a) { fav.list = localFavs(); fav.mode = 'local'; fav.ready = Promise.resolve(); return; }
    var c = store.get(KEY_FAV_ACC, null);
    if (c && c.key === accKey(a) && Array.isArray(c.favs)) { fav.list = cleanFavs(c.favs); fav.scope = c.scope || ''; fav.mode = 'account'; }
    else { fav.list = localFavs(); fav.mode = 'pending'; }
    var rev0 = fav.rev;
    fav.ready = favApi('GET').then(function (j) {
      if (!j.loggedIn) { fav.acct = null; fav.mode = 'local'; fav.list = localFavs(); return; }
      var local = localFavs();
      if (!local.length) { if (fav.rev === rev0) takeServer(j); return; }    /* a save made meanwhile already brought a fresher list */
      return favApi('POST', { merge: local }).then(function (m) { store.del(KEY_FAV); if (!fav.inflight) takeServer(m); })
        .catch(function () { takeServer(j); local.forEach(function (h) { if (!isFav(h)) fav.list.push(h); }); });   /* merge next time */
    }).catch(function () {
      if (fav.mode === 'pending') { fav.mode = 'local'; fav.list = localFavs(); }   /* no Batida Connect: this browser's list, no error */
    }).then(favEmit);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bkv-fav]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    toggleFav(b.getAttribute('data-bkv-fav'));
  });

  /* review banner with a discount switch, like Aleksandra's previews */
  function reviewBanner(host, text) {
    if (!review || !host || host.querySelector('.bv-review')) return;
    var t = tier();
    var div = document.createElement('div'); div.className = 'bv-review';
    /* items wrap as whole units (no " · " left dangling at a line end on phones) */
    div.innerHTML = '<b>PODGLĄD</b><span>' + esc(text || 'widok zalogowanej firmy (dane przykładowe)') + '</span>' +
      '<span class="bv-review__item">rabat <select aria-label="Rabat w podglądzie">' + [0, 5, 7, 10].map(function (v) { return '<option value="' + v + '"' + (v === t ? ' selected' : '') + '>' + v + '%</option>'; }).join('') + '</select></span>' +
      '<a href="?podglad=0" style="color:inherit">wyłącz podgląd</a>';
    div.querySelector('select').addEventListener('change', function (e) { session.set(KEY_TIER, e.target.value); location.reload(); });
    host.insertBefore(div, host.firstChild);
  }

  window.BKV = {
    review: review, previewable: previewable, t: t, pairText: pairText, esc: esc, zl: zl, tier: tier, net: net, netAfter: netAfter, grossAfter: grossAfter, lineNet: lineNet,
    parsePair: parsePair, coffee: coffee, setCoffee: setCoffee, fitsCoffee: fitsCoffee, ROASTS: ROASTS, splitList: splitList, hasAllergen: hasAllergen,
    toast: toast, cartFetch: cartFetch, cartNet: cartNet, cartAdd: cartAdd, snapshot: snapshot, readJSON: readJSON,
    favs: favs, toggleFav: toggleFav, setFav: setFav, isFav: isFav, favButton: favButton, syncFavButtons: syncFavButtons, FAV_ICON: FAV_ICON,
    favMode: function () { return fav.mode; }, favScope: function () { return fav.scope; }, favAccount: function () { return !!fav.acct; },
    favsReady: function () { return fav.ready || Promise.resolve(); },
    store: store, reviewBanner: reviewBanner,
    /* Delivery for companies, from Batida Connect (Strefy i stawki → Firmy; the free-delivery bar prints it into
       window.batidaFD.rates): today 49,20 zł gross = 40 zł netto, free from 1000 zł netto (28.09). With the company rules off, companies pay the
       consumer rates (50 zł Warsaw, 75 zł surroundings, free from 500 zł). The checkout compares the cart value
       before discounts, gross, so the bars measure the same thing. */
    /* 28.09 (Pat, B2B terms "od 1000 zł netto"): with a net threshold from Batida Connect (b2b.freeFromNet) the bars
       measure the cart's NET value before discounts (each line: price ÷ (1 + VAT), syrups 23 %, the rest 5 %), the
       same as the checkout. */
    get NET() { var r = fdRates(); return !!(r.b2b.on && r.b2b.freeFromNet); },
    get FREE() { var r = fdRates(); return r.b2b.on ? (r.b2b.freeFromNet || r.b2b.freeFrom) : r.freeFrom; },
    unitBasis: function (gross, vat) { return this.NET ? Math.round(gross / (1 + (vat || 5) / 100)) : gross; },
    get PRICE() { var r = fdRates(); return r.b2b.on ? r.b2b.price : r.warsaw; },
    get FREE_TXT() { return zlRound(this.FREE) + (this.NET ? ' ' + t('net', 'netto') : ''); },
    /* consumer delivery prices always with grosze (29.09: "50,00 zł"); the threshold (FREE_TXT) stays a whole number.
       3.10 (Aleksandra): the company price reads NET, a whole number when it has no grosze ("40 zł netto"); Connect keeps
       the gross rate (4920 = 40,00 zł + 23 % VAT). Revert: zl(r.b2b.price) in PRICE_TXT / DELIVERY_TXT (git). */
    get PRICE_NET() { var r = fdRates(); return Math.round((Number(r.b2b.price) || 0) / 1.23); },
    get PRICE_TXT() { var r = fdRates(); return r.b2b.on ? zlRound(this.PRICE_NET) + ' ' + t('net', 'netto') : t('price_zones', '[warsaw] w Warszawie, [okolice] w okolicach', { warsaw: zl(r.warsaw), okolice: zl(r.okolice) }); },
    get DELIVERY_TXT() { var r = fdRates(); return r.b2b.on ? t('delivery_b2b', 'dostawa [price], gratis od [free]', { price: this.PRICE_TXT, free: this.FREE_TXT }) : t('delivery_zones', 'dostawa [warsaw], okolice [okolice], gratis od [free]', { warsaw: zl(r.warsaw), okolice: zl(r.okolice), free: this.FREE_TXT }); },
    cartBasis: function (cart) {
      if (!cart) return 0;
      if (this.NET) return (cart.items || []).reduce(function (s, it) { var vat = /syrop/i.test(it.product_type || '') ? 23 : 5; return s + Math.round((it.original_line_price != null ? it.original_line_price : it.final_line_price) / (1 + vat / 100)); }, 0);
      return (typeof cart.original_total_price === 'number' ? cart.original_total_price : cart.total_price) || 0;
    },
    companyProfile: function () { return !!company() || review; }
  };
  favInit();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncFavButtons); else syncFavButtons();
})();
